<div class="logo-container"><img class="logo" src="./lockup-white.png" alt="University Libraries logo lockup" /></div>